// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ox","tile":"oy","imageWrapper":"oz","img":"oA","header":"oB","caption":"oC"};